/**
 * Prompt categories and difficulty levels.
 *
 * To add a new category:
 *   1. Add an entry here
 *   2. Use its `id` as the `category` value in prompt files
 */

export const categories = [
  { id: 'cicd',       label: 'CI/CD',                    color: '#38bdf8', icon: 'CICD' },
  { id: 'iac',        label: 'Infrastructure as Code',   color: '#a78bfa', icon: 'IaC' },
  { id: 'monitoring', label: 'Monitoring & Observability', color: '#34d399', icon: 'Monitoring' },
  { id: 'security',   label: 'Security & Compliance',    color: '#f472b6', icon: 'Security' },
  { id: 'incident',   label: 'Incident Response',        color: '#fb923c', icon: 'Incident' },
  { id: 'containers', label: 'Containers & K8s',         color: '#fbbf24', icon: 'Containers' },
];

export const difficulties = ['beginner', 'intermediate', 'advanced'];
